import { render, staticRenderFns } from "./reset-reminder.vue?vue&type=template&id=a7f8ad2a&"
import script from "./reset-reminder.vue?vue&type=script&lang=js&"
export * from "./reset-reminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports